<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h4>{{ title }}</h4>
      </v-flex>
      <v-flex xs12>
        <div v-if="error" class="red--text">Please select {{ title }}</div>
      </v-flex>
      <v-flex xs4 v-for="(option, index) in options" :key="index" @click="selectOption(option)">
        <v-card :flat="selectedOption != option" class="tile">
          {{ option }}
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      required: true
    },
    value: {
      required: false
    },
    options: {
      required: true
    },
    error: false,
    edit: {
      default: ''
    }
  },
  data () {
    return {
      selectedOption: null
    }
  },
  mounted () {
    this.setValue(this.value)
  },
  watch: {
    value: function (val) {
      this.selectedOption = val
    }
  },
  methods: {
    selectOption (option) {
      this.selectedOption = option
      this.$emit('selected-option', option)
    },

    setValue (value) {
      if (value) {
        // console.log(value)
        this.selectOption(value)
      }
    }
  }
}
</script>
<style scoped>
  .tile {
    text-align: center;
    padding: 10px;
    overflow: hidden;
    cursor: pointer;
    border: solid 1px #ccc !important;
  }

  .tile.elevation-2 {
    border-color: #e83b68 !important;
  }

  .tile:not(.v-card--flat) {
    border-color: #e83b68 !important;
  }

  .tile:hover {
    background: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/CustomizationSelector.vue